/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Prep_Type_Switch_StructureInputs */



/**
* | output |
* | --- |
* | "Keep my text" |
*
* @param {Meeting_Prep_Type_Switch_StructureInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_prep_type_switch_structure = /** @type {((inputs?: Meeting_Prep_Type_Switch_StructureInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Prep_Type_Switch_StructureInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Mijn tekst behouden")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Garder mon texte")
	return /** @type {LocalizedString} */ ("Keep my text")
});